import * as React from "react";
import { Container } from "semantic-ui-react";

export const Home: React.FunctionComponent = () => (
    <Container>
    </Container>);
